import * as types from '~/store/mutation-types'
import EventBus from '~/plugins/event-bus'

export default {
	props: [
		'question',
		'field',
		'index'
	],

	data: function () {
		return {
			isVisible: true
		}
	},

	watch: {
		isVisible: function (newValue, oldValue) {
			if (newValue !== oldValue) {
				this.$emit('visibilityChanged', { form_key: this.field.form_key, isVisible: this.isVisible })
			}
		}
	},

	mounted: function () {
		this.show()

		EventBus.$on('answerEvent', (data) => {
			this.show()
		})
	},

	methods: {
		show: function () {
			if (this.field.required_if === null) {
				this.isVisible = true
				return
			}

      // check answers for the required field type
      // if none - return false
			const answer = this.$store.getters['form/getAnswerByKey'](this.field.required_if)
			if (!answer) {
        // no answer set so we should not show
				this.isVisible = false
				return
			}
			if (this.field.form_key == 'able-to-provide-landlord-permission') {
				if (answer.value != 'Yes') {
					this.isVisible = true
					return
				} else {
					this.isVisible = false
				}
			}

      // check the answer value matches the requirement value
			if (this.field.required_if_value.substr(0, 1) === '!') {
				const value = this.field.required_if_value.substr(1)
				if (value.toLowerCase() == answer.value.toLowerCase()) {
					this.isVisible = false
					return
				}
				this.isVisible = true
				return
			}

			if (answer.value == this.field.required_if_value) {
				this.isVisible = true
				return
			}
			this.isVisible = false
		}
	},

	computed: {
		answer: {
			get: function () {
				const answer = this.$store.getters['form/getAnswerByKey'](this.field.form_key)
				if (answer !== undefined) {
					return answer.value
				}
			},
			set: function (value) {
				const oAnswer = { key: this.field.form_key, value: value }
				this.$store.commit(`form/${types.ADD_ANSWER}`, oAnswer)
				EventBus.$emit('answerEvent', oAnswer)
			}
		}

	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/components/forms/mixins/elements.js